import DatePanel from "react-multi-date-picker/plugins/date_panel";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { get } from "lodash";
import { CalendarIcon } from "components/Layout/MainLayout/Sidebar/icons/CalendarIcon";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, InputAdornment, TextField } from "@mui/material";

interface IDatePickerProps {
  name: string;
  control: any;
  label: string;
  helperText: string;
  multiple: boolean;
  defaultValue?: any;
  style?: any;
  hideTimePicker?: boolean;
  onlyMonthPicker?: boolean;
  onlyYearPicker?: boolean;
  iconColor?: string;
}

export const DateTimePicker = ({
  name,
  control,
  label,
  helperText,
  multiple,
  defaultValue,
  style,
  hideTimePicker,
  onlyMonthPicker,
  onlyYearPicker,
  iconColor,
}: IDatePickerProps) => {
  const {
    formState: { errors },
  } = useFormContext();

  const monthsInSpanish: string[][] = [
    ["Ene","Enero"],
    ["Feb","Febrero"],
    ["Mar","Marzo"],
    ["Abr","Abril"],
    ["May","Mayo"],
    ["Jun","Junio"],
    ["Jul","Julio"],
    ["Ago","Agosto"],
    ["Sep","Septiembre"],
    ["Oct","Octubre"],
    ["Nov","Noviembre"],
    ["Dic","Diciembre"],
  ];

  const weekDaysInSpanish: string[] = [
    "Lun",
    "Mar",
    "Mie",
    "Jue",
    "Vie",
    "Sab",
    "Dom"
  ]

  const getFormatByTypeOfPicker = () => {
    if (hideTimePicker) {
      return "DD/MM/YYYY";
    } else if (onlyMonthPicker) {
      return "MMM";
    } else if (onlyYearPicker) {
      return "YYYY";
    } else {
      return "DD/MM/YYYY HH:mm";
    }
  };

  const getPluginsByTypeOfPicker = () => {
    if (!(hideTimePicker || onlyMonthPicker || onlyYearPicker)) {
      return [
        <TimePicker hideSeconds position="bottom" />,
        <DatePanel markFocused />,
      ];
    }
    return [];
  };

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { value, name, onChange } }) => {
        const handleChange = (newValue: any) => {
          // Si el nuevo valor es una cadena vacía, establecer como undefined
          onChange(newValue === null ? undefined : newValue);
        };
        return (
          <FormControl
            fullWidth
            error={!!errors[name]}
            className={errors[name] ? "error" : ""}
          >
            <DatePicker
              months={monthsInSpanish}
              weekDays={weekDaysInSpanish}
              format={getFormatByTypeOfPicker()}
              onlyMonthPicker={onlyMonthPicker}
              onlyYearPicker={onlyYearPicker}
              showOtherDays
              range={multiple}
              rangeHover={multiple}
              style={{
                height: "63px",
                color: "black",
                fontSize: "1rem",
                fontWeight: 400,
                width: "100%",
                ...style,
              }}
              plugins={getPluginsByTypeOfPicker()}
              value={value}
              name={name}
              onChange={handleChange}
              placeholder={label}
              render={
                <TextField
                  fullWidth
                  label={label}
                  name={name}
                  value={value}
                  error={!!errors[name]}
                  helperText={
                    get(errors, name)
                      ? (get(errors, `${name}.message`) as unknown as string)
                      : helperText
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CalendarIcon sx={{ fill: iconColor || "#D0D5DD" }} />
                      </InputAdornment>
                    ),
                  }}
                />
              }
            />
          </FormControl>
        );
      }}
    />
  );
};
